/** `0:24`, `56:52` — the design's countdown format: minutes unpadded, seconds to two digits. Never raw seconds, so an hour-long wait stays readable. */
export function formatCooldown(totalSeconds: number): string {
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes}:${String(seconds).padStart(2, '0')}`
}
